import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { Section } from "./Section";
import { guaranteeItems } from "../data/landing";
export function Guarantee() {
  return <Section tone="navy" cta="Get Access With the 7-Day Guarantee" data-id="element-152" data-mp="2236cg4d6qnxj">
      <div className="mx-auto grid max-w-5xl items-center gap-10 md:grid-cols-[220px_1fr]" data-id="element-153" data-mp="221bvf151bfyq">
        <div className="mx-auto flex h-48 w-48 flex-col items-center justify-center rounded-full bg-gold text-ink ring-8 ring-gold/20 md:h-56 md:w-56" data-id="element-154" data-mp="1x28rxl4pdhsv">
          <ShieldCheckIcon className="h-12 w-12" aria-hidden="true" data-id="element-155" data-mp="14gfnz87o7x4i" />
          <span className="mt-1 font-serif text-5xl font-extrabold leading-none" data-id="element-156" data-mp="1j4ka6m5xmqs1">7</span>
          <span className="text-sm font-extrabold uppercase tracking-widest" data-id="element-157" data-mp="1j6dcjp9iiou8">Day guarantee</span>
        </div>

        <div className="text-center md:text-left" data-id="element-158" data-mp="qnzqso1gatbi">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold sm:text-sm" data-id="element-159" data-mp="qmom8m06lhjc">Your purchase is protected</p>
          <h2 className="mt-3 font-serif text-[2rem] font-bold leading-tight text-cream sm:text-5xl" data-id="element-160" data-mp="ln290ckcs1aj">
            A 7-Day Money-Back Guarantee
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-161" data-mp="txkvr892ng27">
            I want you to have the opportunity to review the materials and decide whether they meet your educational
            needs. After purchasing, you can:
          </p>
          <ul className="mx-auto mt-5 max-w-md space-y-2.5 text-left md:mx-0" data-id="element-162" data-mp="60nivd3p94df">
            {guaranteeItems.map(item => <li key={item} className="flex gap-2.5 text-base text-cream" data-id="element-163" data-mp="az8mznm2o875">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-164" data-mp="f1by2b4txarw" />
                {item}
              </li>)}
          </ul>
          <p className="mt-5 text-base leading-relaxed text-muted" data-id="element-165" data-mp="jyc4in5lcfjj">
            If you decide within seven days that the collection is not right for you, contact our support team according
            to the refund instructions provided with your purchase. If your request meets the stated guarantee terms,
            you will receive a refund of your purchase price.
          </p>
          <p className="mt-3 text-base font-semibold text-cream" data-id="element-166" data-mp="3ngvcjge932ez">
            You can review the collection without committing to a long-term subscription.
          </p>
        </div>
      </div>
    </Section>;
}